import Explainer from '../blocks';
import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import * as styles from './ImproveDecisionMaking.module.css';

const ImproveDecisionMaking = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <Explainer width={662} height={460} className={styles.root}>
      <g transform="translate(32, 65)" ref={ref}>
        <motion.g
          className={styles.bar}
          filter="url(#filter0_d_2375_90772)"
          initial={{ y: 150 }}
          animate={{ y: isInView ? 0 : 150 }}
          transition={{ duration: 0.7, ease: 'easeInOut' }}
        >
          <rect
            x="30"
            y="10.2148"
            width="537"
            height="37.9053"
            rx="4"
            fill="white"
          />
          <g>
            <rect
              x="76.5742"
              y="33.1978"
              width="4.67842"
              height="1.05988"
              transform="rotate(-45 76.5742 33.1978)"
              fill="#5F7886"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M82.6327 30.3392C84.0636 30.3392 85.2235 29.1793 85.2235 27.7484C85.2235 26.3175 84.0636 25.1575 82.6327 25.1575C81.2018 25.1575 80.0418 26.3175 80.0418 27.7484C80.0418 29.1793 81.2018 30.3392 82.6327 30.3392ZM82.6327 31.3991C84.6489 31.3991 86.2834 29.7646 86.2834 27.7484C86.2834 25.7321 84.6489 24.0977 82.6327 24.0977C80.6164 24.0977 78.9819 25.7321 78.9819 27.7484C78.9819 29.7646 80.6164 31.3991 82.6327 31.3991Z"
              fill="#5F7886"
            />
          </g>
          <g>
            <path
              d="M42.9712 26.1357H53.6948V27.2607H42.9712V26.1357Z"
              fill="#7A8B95"
            />
            <path
              d="M44.7556 29.1357H51.9105V30.2607H44.7556V29.1357Z"
              fill="#7A8B95"
            />
            <path
              d="M46.54 32.1357H50.1261V33.2607H46.54V32.1357Z"
              fill="#7A8B95"
            />
          </g>
          <line
            x1="65.5"
            y1="10.2148"
            x2="65.5"
            y2="48.2148"
            stroke="#E6EAEC"
          />
          <text
            x="96"
            y="34"
            fontSize="14px"
            fontFamily="var(--font-family-body)"
            fill="var(--brand-color-grey-9)"
            opacity="0.66"
          >
            Search log entries
          </text>
        </motion.g>
        <motion.g
          className={styles.list}
          filter="url(#filter1_d_2375_90772)"
          initial={{ y: 120 }}
          animate={{ y: isInView ? 0 : 120 }}
          transition={{ duration: 0.7, ease: 'easeInOut' }}
        >
          <g>
            <g>
              <rect x="30" y="56.2148" width="537" height="44" fill="#FAFCFC" />
              <path
                d="M566 56.2148V100.215H568V56.2148H566Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-12-inside-2_2375_90772)"
              />
              <rect
                x="46"
                y="80.2148"
                width="14"
                height="14"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="66"
                y="80.2148"
                width="14"
                height="14"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="86"
                y="80.2148"
                width="14"
                height="14"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="106"
                y="88.2148"
                width="14"
                height="6"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="126"
                y="88.2148"
                width="14"
                height="6"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect x="146" y="84.2148" width="14" height="2" fill="#B73B55" />
              <rect
                x="146"
                y="86.2148"
                width="14"
                height="8"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="166"
                y="88.2148"
                width="14"
                height="6"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="186"
                y="88.2148"
                width="14"
                height="6"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="206"
                y="83.2148"
                width="14"
                height="11"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="226"
                y="83.2148"
                width="14"
                height="11"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="246"
                y="72.2148"
                width="14"
                height="22"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect x="266" y="84.2148" width="14" height="2" fill="#BF810B" />
              <rect
                x="266"
                y="86.2148"
                width="14"
                height="8"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="286"
                y="72.2148"
                width="14"
                height="22"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="306"
                y="72.2148"
                width="14"
                height="22"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="326"
                y="81.2148"
                width="14"
                height="13"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="346"
                y="88.2148"
                width="14"
                height="6"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="366"
                y="77.2148"
                width="14"
                height="17"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="386"
                y="81.2148"
                width="14"
                height="13"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="406"
                y="81.2148"
                width="14"
                height="13"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect x="426" y="83.2148" width="14" height="5" fill="#B73B55" />
              <rect x="426" y="82.2148" width="14" height="1" fill="#BF810B" />
              <rect
                x="426"
                y="88.2148"
                width="14"
                height="6"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="446"
                y="88.2148"
                width="14"
                height="6"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="466"
                y="72.2148"
                width="14"
                height="22"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="486"
                y="81.2148"
                width="14"
                height="13"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="506"
                y="88.2148"
                width="14"
                height="6"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect
                x="526"
                y="88.2148"
                width="14"
                height="6"
                fill="#092F45"
                fillOpacity="0.15"
              />
              <rect x="546" y="83.2148" width="14" height="1" fill="#B73B55" />
              <rect x="546" y="82.2148" width="14" height="1" fill="#BF810B" />
              <rect
                x="546"
                y="84.2148"
                width="14"
                height="10"
                fill="#092F45"
                fillOpacity="0.15"
              />
            </g>
            <path
              d="M567 99.2148H30V101.215H567V99.2148Z"
              fill="#092F45"
              fillOpacity="0.05"
              mask="url(#path-10-inside-1_2375_90772)"
            />
            <g>
              <mask id="path-46-inside-3_2375_90772" fill="white">
                <path d="M30 100.215H146V144.215H30V100.215Z" />
              </mask>
              <path d="M30 100.215H146V144.215H30V100.215Z" fill="white" />
              <path
                d="M145 100.215V144.215H147V100.215H145Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-46-inside-3_2375_90772)"
              />
              <text
                x="46"
                y="127"
                fontSize="11px"
                fontFamily="var(--font-family-mono)"
                fill="#4E6978"
              >
                GET
              </text>
              <rect
                x="98"
                y="110.715"
                width="36"
                height="23"
                rx="4"
                fill="#E2FCF0"
              />
              <text
                x="106"
                y="126"
                fontSize="10px"
                fontFamily="var(--font-family-mono)"
                letterSpacing="0.04em"
                fill="#005346"
              >
                200
              </text>
              <mask id="path-51-inside-4_2375_90772" fill="white">
                <path d="M146 100.215H292V144.215H146V100.215Z" />
              </mask>
              <path d="M146 100.215H292V144.215H146V100.215Z" fill="white" />
              <path
                d="M291 100.215V144.215H293V100.215H291Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-51-inside-4_2375_90772)"
              />
              <g>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M163.344 119.892C163.344 118.425 164.533 117.235 166 117.235C167.467 117.235 168.656 118.425 168.656 119.892C168.656 121.359 167.467 122.548 166 122.548C164.533 122.548 163.344 121.359 163.344 119.892ZM162.344 119.892C162.344 117.872 163.981 116.235 166 116.235C168.019 116.235 169.656 117.872 169.656 119.892C169.656 121.911 168.019 123.548 166 123.548C163.981 123.548 162.344 121.911 162.344 119.892ZM162.943 125.681L160.859 128.025L160.112 127.361L162.494 124.681H165.143H166.857H169.506L171.888 127.361L171.141 128.025L169.057 125.681H166.857H165.143H162.943Z"
                  fill="#7A8B95"
                />
              </g>
              <text
                x="186"
                y="127"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                Martin Synott
              </text>
              <rect
                width="275"
                height="44"
                transform="translate(292 100.215)"
                fill="white"
              />
              <path
                d="M318.452 121.491H320.115C320.154 121.491 320.191 121.476 320.218 121.449C320.245 121.421 320.261 121.385 320.261 121.346V119.864C320.261 119.826 320.246 119.789 320.218 119.761C320.191 119.734 320.154 119.718 320.115 119.718H318.452C318.413 119.718 318.376 119.734 318.349 119.761C318.322 119.788 318.306 119.825 318.306 119.864V121.346C318.306 121.426 318.371 121.491 318.452 121.491ZM316.132 117.228H317.795C317.834 117.228 317.871 117.213 317.898 117.185C317.926 117.158 317.941 117.121 317.941 117.082V115.6C317.941 115.561 317.926 115.524 317.898 115.497C317.871 115.47 317.834 115.455 317.795 115.455H316.132C316.094 115.455 316.057 115.47 316.03 115.497C316.002 115.524 315.987 115.561 315.987 115.6V117.082C315.987 117.162 316.052 117.228 316.132 117.228ZM316.132 119.36H317.795C317.834 119.359 317.871 119.344 317.898 119.317C317.926 119.289 317.941 119.252 317.941 119.214V117.732C317.941 117.694 317.926 117.657 317.898 117.629C317.871 117.602 317.834 117.587 317.795 117.587H316.132C316.094 117.587 316.057 117.602 316.03 117.629C316.002 117.657 315.987 117.694 315.987 117.732V119.214C315.987 119.294 316.052 119.359 316.132 119.36ZM313.832 119.36H315.496C315.535 119.359 315.572 119.344 315.599 119.316C315.626 119.289 315.641 119.252 315.641 119.214V117.732C315.641 117.694 315.626 117.657 315.598 117.629C315.571 117.602 315.534 117.587 315.496 117.587H313.833C313.794 117.587 313.757 117.602 313.73 117.629C313.703 117.657 313.688 117.694 313.688 117.732V119.214C313.688 119.294 313.752 119.359 313.832 119.36ZM311.506 119.36H313.169C313.208 119.359 313.245 119.344 313.272 119.317C313.299 119.289 313.315 119.252 313.315 119.214V117.732C313.315 117.694 313.299 117.657 313.272 117.629C313.245 117.602 313.208 117.587 313.169 117.587H311.506C311.467 117.587 311.43 117.602 311.403 117.629C311.376 117.657 311.36 117.694 311.36 117.732V119.214C311.36 119.294 311.426 119.359 311.506 119.36ZM316.132 121.491H317.795C317.834 121.491 317.871 121.476 317.898 121.449C317.926 121.421 317.941 121.385 317.941 121.346V119.864C317.941 119.826 317.926 119.789 317.898 119.761C317.871 119.734 317.834 119.718 317.795 119.718H316.132C316.094 119.718 316.057 119.734 316.03 119.761C316.002 119.788 315.987 119.825 315.987 119.864V121.346C315.987 121.426 316.052 121.491 316.132 121.491ZM313.832 121.491H315.496C315.535 121.491 315.572 121.476 315.599 121.448C315.626 121.421 315.641 121.384 315.641 121.346V119.864C315.641 119.845 315.637 119.826 315.63 119.809C315.623 119.791 315.612 119.775 315.599 119.761C315.586 119.748 315.57 119.737 315.552 119.73C315.534 119.722 315.516 119.719 315.496 119.718H313.832C313.794 119.719 313.757 119.734 313.73 119.761C313.703 119.788 313.688 119.825 313.688 119.864V121.346C313.688 121.426 313.752 121.491 313.832 121.491ZM311.506 121.491H313.169C313.208 121.491 313.245 121.476 313.272 121.449C313.299 121.421 313.315 121.384 313.315 121.346V119.864C313.315 119.845 313.311 119.826 313.304 119.809C313.297 119.791 313.286 119.775 313.273 119.761C313.259 119.748 313.243 119.737 313.226 119.73C313.208 119.722 313.189 119.719 313.17 119.718H311.506C311.467 119.718 311.43 119.734 311.403 119.761C311.375 119.789 311.36 119.826 311.36 119.864V121.346C311.36 121.426 311.426 121.491 311.506 121.491ZM309.213 121.491H310.878C310.916 121.491 310.953 121.476 310.98 121.448C311.007 121.421 311.022 121.384 311.022 121.346V119.864C311.022 119.845 311.019 119.826 311.011 119.809C311.004 119.791 310.994 119.775 310.98 119.761C310.967 119.748 310.951 119.737 310.933 119.73C310.916 119.722 310.897 119.719 310.878 119.718H309.213C309.175 119.719 309.138 119.734 309.111 119.761C309.084 119.788 309.069 119.825 309.069 119.864V121.346C309.069 121.426 309.133 121.491 309.213 121.491ZM326.13 120.558C326.079 120.518 325.602 120.158 324.596 120.158C324.33 120.159 324.065 120.182 323.803 120.226C323.608 118.892 322.505 118.24 322.455 118.212L322.185 118.056L322.008 118.312C321.785 118.656 321.623 119.036 321.527 119.435C321.347 120.197 321.457 120.913 321.844 121.524C321.377 121.785 320.627 121.848 320.475 121.854H308.063C307.907 121.854 307.758 121.916 307.648 122.026C307.537 122.136 307.475 122.285 307.474 122.441C307.46 123.528 307.644 124.609 308.018 125.63C308.446 126.751 309.082 127.577 309.91 128.083C310.836 128.65 312.344 128.975 314.051 128.975C314.823 128.978 315.592 128.908 316.351 128.767C317.406 128.573 318.42 128.204 319.353 127.676C320.122 127.231 320.813 126.665 321.402 125.999C322.385 124.886 322.97 123.646 323.406 122.545H323.58C324.657 122.545 325.319 122.114 325.684 121.753C325.926 121.523 326.116 121.242 326.239 120.931L326.316 120.705L326.13 120.558Z"
                fill="#768FA2"
              />
              <text
                x="340"
                y="127"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                tensorflow/tensorflow
              </text>
            </g>
            <g>
              <mask id="path-57-inside-5_2375_90772" fill="white">
                <path d="M30 144.215H146V188.215H30V144.215Z" />
              </mask>
              <path d="M30 144.215H146V188.215H30V144.215Z" fill="#FFF2F5" />
              <path
                d="M145 144.215V188.215H147V144.215H145Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-57-inside-5_2375_90772)"
              />
              <text
                x="46"
                y="170"
                fontSize="11px"
                fontFamily="var(--font-family-mono)"
                fill="#B73B55"
              >
                GET
              </text>
              <rect
                x="98"
                y="154.715"
                width="36"
                height="23"
                rx="4"
                fill="#B73B55"
              />
              <text
                x="106"
                y="170"
                fontSize="10px"
                fontFamily="var(--font-family-mono)"
                letterSpacing="0.04em"
                fill="white"
              >
                403
              </text>
              <mask id="path-62-inside-6_2375_90772" fill="white">
                <path d="M146 144.215H292V188.215H146V144.215Z" />
              </mask>
              <path d="M146 144.215H292V188.215H146V144.215Z" fill="#FFF2F5" />
              <path
                d="M291 144.215V188.215H293V144.215H291Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-62-inside-6_2375_90772)"
              />
              <g>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M164.251 162.382L166.728 159.905H168.536L171.012 162.382V164.19L168.536 166.666H166.728L165.897 165.835L164.216 167.516L166.005 169.304L165.298 170.011L163.509 168.223L161.988 169.744V170.295L163.51 171.818L162.803 172.525L160.988 170.709V169.33L165.19 165.128L164.251 164.19V162.382ZM165.251 162.796V163.776L167.142 165.666H168.122L170.012 163.776V162.796L168.122 160.905L167.142 160.905L165.251 162.796Z"
                  fill="#5F7886"
                />
              </g>
              <text
                x="186"
                y="171"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                pub_token
              </text>
              <rect
                width="275"
                height="44"
                transform="translate(292 144.215)"
                fill="#FFF2F5"
              />
              <path
                d="M308.808 155.139C308.52 155.127 308.194 155.205 308.043 155.561C307.898 155.906 307.782 156.657 307.73 157.662L308.858 158.207C308.84 157.527 308.865 156.887 308.929 156.3C308.905 156.576 308.877 157.186 308.934 158.182C308.952 158.498 308.979 158.851 309.015 159.244C309.017 159.266 309.017 159.287 309.022 159.307C309.097 160.052 309.192 160.794 309.307 161.534C309.36 161.874 309.423 162.228 309.487 162.605L309.478 162.614C309.491 162.623 309.492 162.63 309.491 162.635L309.518 162.783C309.546 162.932 309.574 163.086 309.604 163.239L309.704 163.749L309.756 164.016C309.885 164.655 310.026 165.291 310.178 165.925C310.261 166.277 310.349 166.645 310.442 167.02C310.533 167.376 310.626 167.742 310.728 168.121C310.816 168.455 310.911 168.799 311.007 169.152C311.01 169.169 311.018 169.185 311.021 169.203C311.124 169.568 311.229 169.932 311.335 170.297L311.38 170.457C311.452 170.698 311.526 170.949 311.604 171.2C311.512 171.162 311.422 171.121 311.333 171.076L311.158 170.472C311.139 170.401 311.119 170.335 311.101 170.264L311.099 170.261L311.095 170.259C311.015 169.982 310.938 169.698 310.858 169.413C310.837 169.333 310.817 169.253 310.794 169.17L310.504 168.083C310.412 167.731 310.325 167.377 310.237 167.018C310.15 166.658 310.066 166.298 309.981 165.936C309.895 165.566 309.814 165.197 309.736 164.825C309.658 164.46 309.588 164.089 309.515 163.724C309.446 163.365 309.381 163.005 309.32 162.644C309.316 162.632 309.314 162.617 309.311 162.606L309.314 162.605C309.262 162.248 309.207 161.894 309.154 161.543C309.103 161.173 309.055 160.803 309.012 160.432C308.926 159.693 308.873 158.951 308.853 158.207L307.727 157.663C307.723 157.731 307.718 157.801 307.715 157.875C307.704 158.146 307.696 158.433 307.694 158.733C307.691 159.089 307.693 159.445 307.699 159.801C307.707 160.143 307.722 160.498 307.741 160.861C307.759 161.171 307.779 161.484 307.805 161.804L307.807 161.84L307.813 161.844C307.815 161.865 307.819 161.89 307.818 161.914C307.849 162.254 307.877 162.596 307.917 162.943C307.99 163.6 308.083 164.254 308.197 164.905C308.206 164.964 308.219 165.026 308.229 165.085C308.361 165.807 308.529 166.522 308.734 167.226C308.798 167.445 308.863 167.655 308.928 167.854C308.986 168.022 309.048 168.191 309.107 168.357C309.25 168.747 309.409 169.125 309.579 169.494L309.585 169.498C309.59 169.514 309.596 169.529 309.603 169.544C309.811 169.992 310.042 170.421 310.3 170.832C310.31 170.844 310.319 170.862 310.328 170.875C309.908 170.706 309.166 170.785 309.171 170.786C309.938 171.052 310.609 171.377 311.032 171.87C310.863 172.055 310.55 172.195 310.153 172.311C310.701 172.37 311.006 172.275 311.117 172.226C310.831 172.466 310.671 172.901 310.531 173.37C310.854 172.844 311.174 172.494 311.485 172.361C311.557 172.599 311.634 172.844 311.71 173.088C311.002 174.477 310.317 175.879 309.657 177.292C309.742 177.28 309.822 177.248 309.892 177.198C309.961 177.147 310.017 177.081 310.054 177.004C310.174 176.743 310.82 175.365 311.815 173.427C312.196 174.629 312.627 175.9 313.094 177.22C313.141 177.16 313.172 177.089 313.184 177.014C313.196 176.939 313.19 176.862 313.165 176.79C312.738 175.585 312.335 174.371 311.957 173.149C312.099 172.873 312.249 172.584 312.404 172.289C312.519 172.325 312.639 172.375 312.763 172.432C312.95 172.603 313.088 172.885 313.208 173.207C313.242 172.842 313.131 172.478 312.9 172.193C314.132 172.432 315.251 172.277 315.934 171.446C315.996 171.369 316.055 171.289 316.111 171.208C315.811 171.488 315.481 171.581 314.899 171.46C315.818 171.2 316.305 170.89 316.777 170.333C316.888 170.2 317.003 170.054 317.12 169.89C316.249 170.557 315.341 170.649 314.443 170.345L314.401 170.329C315.245 170.347 316.435 169.891 317.256 169.231C317.634 168.927 317.99 168.557 318.336 168.114C318.594 167.783 318.843 167.413 319.093 166.992C319.309 166.629 319.525 166.231 319.739 165.798C319.518 165.871 319.288 165.913 319.056 165.925L318.923 165.932C318.878 165.934 318.837 165.932 318.788 165.934C319.605 165.751 320.173 165.251 320.629 164.598C320.407 164.706 320.049 164.84 319.641 164.873C319.587 164.878 319.53 164.878 319.473 164.878C319.461 164.876 319.447 164.878 319.429 164.876C319.712 164.804 319.959 164.712 320.177 164.591C320.292 164.526 320.402 164.453 320.508 164.373C320.548 164.339 320.589 164.309 320.628 164.275C320.719 164.196 320.806 164.109 320.886 164.01C320.912 163.979 320.938 163.952 320.96 163.92C320.993 163.874 321.027 163.829 321.056 163.785C321.227 163.54 321.385 163.285 321.527 163.021C321.541 162.992 321.556 162.968 321.569 162.94C321.606 162.862 321.643 162.792 321.671 162.73C321.709 162.639 321.739 162.565 321.756 162.51C321.724 162.53 321.691 162.546 321.656 162.558C321.404 162.661 320.985 162.73 320.653 162.743C320.65 162.743 320.646 162.743 320.641 162.747H320.58C321.244 162.549 321.565 162.331 321.892 161.992C322.276 161.576 322.632 161.136 322.957 160.674C323.201 160.332 323.424 159.992 323.596 159.684C323.697 159.507 323.789 159.324 323.871 159.138C323.932 158.993 323.984 158.856 324.03 158.722C323.6 158.731 323.12 158.732 322.664 158.722C323.121 158.731 323.601 158.729 324.034 158.718C324.495 157.347 324.092 156.63 324.092 156.63C324.092 156.63 323.606 155.511 322.8 155.844C322.406 156.006 321.718 156.518 320.877 157.284L321.351 158.622C321.842 158.095 322.367 157.601 322.923 157.144C322.686 157.347 322.178 157.814 321.433 158.661C321.196 158.929 320.937 159.237 320.653 159.582C320.638 159.6 320.621 159.617 320.61 159.637C320.08 160.296 319.567 160.969 319.072 161.656C318.843 161.97 318.613 162.306 318.366 162.66H318.351C318.353 162.678 318.348 162.686 318.342 162.69L318.249 162.83C318.153 162.973 318.052 163.116 317.955 163.264L317.63 163.757C317.574 163.84 317.516 163.924 317.459 164.012C317.289 164.273 317.12 164.541 316.944 164.818C316.494 165.531 316.055 166.251 315.625 166.976C315.203 167.691 314.79 168.412 314.388 169.139C314.377 169.155 314.369 169.176 314.356 169.192C314.149 169.567 313.944 169.943 313.74 170.321L313.65 170.488C313.493 170.781 313.331 171.08 313.17 171.391C313.17 171.395 313.166 171.399 313.165 171.403C313.141 171.448 313.118 171.489 313.098 171.533C312.99 171.738 312.897 171.925 312.683 172.337C312.617 172.273 312.545 172.216 312.468 172.169L312.786 171.569C312.83 171.486 312.875 171.405 312.918 171.319L312.955 171.248L313.459 170.324L313.579 170.109V170.104L313.578 170.098C313.734 169.812 313.897 169.526 314.058 169.23C314.105 169.15 314.152 169.071 314.199 168.986C314.406 168.621 314.618 168.253 314.831 167.881C315.463 166.788 316.121 165.71 316.801 164.646C317.029 164.29 317.266 163.936 317.497 163.583C317.582 163.456 317.665 163.332 317.755 163.205C317.901 162.988 318.049 162.772 318.198 162.558C318.205 162.546 318.216 162.535 318.222 162.523H318.228C318.468 162.195 318.705 161.865 318.941 161.54C319.198 161.196 319.453 160.862 319.707 160.534C320.226 159.872 320.773 159.233 321.348 158.619L320.872 157.284C320.817 157.337 320.756 157.391 320.695 157.448C320.458 157.669 320.225 157.893 319.995 158.121C319.723 158.393 319.444 158.681 319.153 158.984C318.636 159.536 318.134 160.102 317.647 160.681L317.619 160.711L317.621 160.719C317.605 160.737 317.591 160.759 317.571 160.778C317.326 161.076 317.075 161.377 316.832 161.687C316.369 162.273 315.924 162.873 315.498 163.487C315.458 163.542 315.42 163.603 315.381 163.659C314.913 164.345 314.481 165.054 314.086 165.785C313.966 166.013 313.849 166.232 313.744 166.445C313.656 166.625 313.572 166.809 313.488 166.99C313.294 167.417 313.12 167.849 312.965 168.281L312.967 168.287C312.958 168.304 312.949 168.322 312.943 168.341C312.843 168.62 312.756 168.902 312.675 169.184C312.546 169.345 312.397 169.484 312.23 169.609C312.191 169.561 312.15 169.514 312.109 169.468C312.517 168.855 312.777 168.157 312.869 167.427C312.918 166.97 312.913 166.509 312.854 166.053C312.812 165.684 312.738 165.296 312.635 164.877C312.545 164.514 312.434 164.129 312.3 163.725C312.216 163.896 312.097 164.064 311.95 164.228L311.87 164.315C311.844 164.345 311.815 164.37 311.786 164.402C312.186 163.78 312.234 163.112 312.116 162.419C312.014 162.706 311.861 162.972 311.664 163.204C311.633 163.239 311.597 163.275 311.562 163.311C311.553 163.317 311.545 163.327 311.532 163.337C311.665 163.115 311.762 162.906 311.825 162.692C311.84 162.648 311.852 162.603 311.862 162.558C311.877 162.489 311.888 162.42 311.897 162.35L311.914 162.215C311.922 162.106 311.922 161.997 311.912 161.888C311.909 161.851 311.908 161.818 311.903 161.784C311.894 161.733 311.888 161.687 311.878 161.642C311.834 161.38 311.774 161.121 311.7 160.866C311.69 160.841 311.686 160.815 311.676 160.789C311.651 160.716 311.631 160.651 311.609 160.596C311.585 160.53 311.557 160.466 311.526 160.403C311.519 160.435 311.508 160.466 311.494 160.495C311.4 160.717 311.18 161.022 310.98 161.234C310.977 161.237 310.973 161.238 310.973 161.243L310.936 161.283C311.23 160.747 311.296 160.41 311.292 159.992C311.275 159.493 311.226 158.995 311.144 158.502C311.091 158.158 311.019 157.818 310.93 157.483C310.883 157.308 310.828 157.136 310.764 156.967C310.715 156.845 310.662 156.725 310.605 156.607L310.607 156.603C310.044 155.453 309.346 155.252 309.346 155.252C309.346 155.252 309.096 155.151 308.808 155.139ZM311.928 169.708L311.957 169.783V169.785C311.902 169.816 311.85 169.847 311.793 169.875C311.782 169.878 311.771 169.886 311.757 169.891C311.818 169.833 311.875 169.771 311.929 169.707L311.928 169.708ZM311.371 171.209C311.491 171.334 311.602 171.432 311.698 171.504L311.762 171.713C311.686 171.725 311.61 171.741 311.535 171.762L311.508 171.672C311.486 171.594 311.463 171.515 311.438 171.435L311.418 171.367L311.371 171.209ZM311.611 172.016C311.695 172.014 311.778 172.018 311.861 172.025L311.926 172.237C312.001 172.223 312.078 172.222 312.154 172.233L311.853 172.812C311.771 172.547 311.691 172.282 311.611 172.016Z"
                fill="#768FA2"
              />
              <text
                x="340"
                y="171"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                junit-jupiter-api
              </text>
            </g>
            <g>
              <mask id="path-68-inside-7_2375_90772" fill="white">
                <path d="M30 188.215H146V232.215H30V188.215Z" />
              </mask>
              <path d="M30 188.215H146V232.215H30V188.215Z" fill="white" />
              <path
                d="M145 188.215V232.215H147V188.215H145Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-68-inside-7_2375_90772)"
              />
              <text
                x="46"
                y="214"
                fontSize="11px"
                fontFamily="var(--font-family-mono)"
                fill="#4E6978"
              >
                GET
              </text>
              <rect
                x="98"
                y="198.715"
                width="36"
                height="23"
                rx="4"
                fill="#E2FCF0"
              />
              <text
                x="106"
                y="214"
                fontSize="10px"
                fontFamily="var(--font-family-mono)"
                letterSpacing="0.04em"
                fill="#005346"
              >
                200
              </text>
              <mask id="path-73-inside-8_2375_90772" fill="white">
                <path d="M146 188.215H292V232.215H146V188.215Z" />
              </mask>
              <path d="M146 188.215H292V232.215H146V188.215Z" fill="white" />
              <path
                d="M291 188.215V232.215H293V188.215H291Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-73-inside-8_2375_90772)"
              />
              <g>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M164.251 206.382L166.728 203.905H168.536L171.012 206.382V208.19L168.536 210.666H166.728L165.897 209.835L164.216 211.516L166.005 213.304L165.298 214.011L163.509 212.223L161.988 213.744V214.295L163.51 215.818L162.803 216.525L160.988 214.709V213.33L165.19 209.128L164.251 208.19V206.382ZM165.251 206.796V207.776L167.142 209.666H168.122L170.012 207.776V206.796L168.122 204.905L167.142 204.905L165.251 206.796Z"
                  fill="#5F7886"
                />
              </g>
              <text
                x="186"
                y="215"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                private_token
              </text>
              <rect
                width="275"
                height="44"
                transform="translate(292 188.215)"
                fill="white"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M307.629 213.107V207.323H309.138V213.107H307.629Z"
                fill="#768FA2"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M319.007 213.107V207.323H320.515V213.107H319.007Z"
                fill="#768FA2"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M322.862 213.107V207.323H324.371V213.107H322.862Z"
                fill="#768FA2"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M314.004 211.753C314.854 211.753 315.543 211.064 315.543 210.215C315.543 209.365 314.854 208.677 314.004 208.677C313.155 208.677 312.466 209.365 312.466 210.215C312.466 211.064 313.155 211.753 314.004 211.753ZM314.004 213.261C315.687 213.261 317.051 211.897 317.051 210.215C317.051 208.532 315.687 207.168 314.004 207.168C312.322 207.168 310.958 208.532 310.958 210.215C310.958 211.897 312.322 213.261 314.004 213.261Z"
                fill="#768FA2"
              />
              <text
                x="340"
                y="215"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                tf-training-data.zip
              </text>
            </g>
            <g>
              <mask id="path-79-inside-9_2375_90772" fill="white">
                <path d="M30 232.215H146V276.215H30V232.215Z" />
              </mask>
              <path d="M30 232.215H146V276.215H30V232.215Z" fill="white" />
              <path
                d="M145 232.215V276.215H147V232.215H145Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-79-inside-9_2375_90772)"
              />
              <text
                x="46"
                y="258"
                fontSize="11px"
                fontFamily="var(--font-family-mono)"
                fill="#4E6978"
              >
                POST
              </text>
              <rect
                x="98"
                y="242.715"
                width="36"
                height="23"
                rx="4"
                fill="#BF810B"
              />
              <text
                x="106"
                y="258"
                fontSize="10px"
                fontFamily="var(--font-family-mono)"
                letterSpacing="0.04em"
                fill="white"
              >
                302
              </text>
              <mask id="path-84-inside-10_2375_90772" fill="white">
                <path d="M146 232.215H292V276.215H146V232.215Z" />
              </mask>
              <path d="M146 232.215H292V276.215H146V232.215Z" fill="white" />
              <path
                d="M291 232.215V276.215H293V232.215H291Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-84-inside-10_2375_90772)"
              />
              <g>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M163.344 251.892C163.344 250.425 164.533 249.235 166 249.235C167.467 249.235 168.656 250.425 168.656 251.892C168.656 253.359 167.467 254.548 166 254.548C164.533 254.548 163.344 253.359 163.344 251.892ZM162.344 251.892C162.344 249.872 163.981 248.235 166 248.235C168.019 248.235 169.656 249.872 169.656 251.892C169.656 253.911 168.019 255.548 166 255.548C163.981 255.548 162.344 253.911 162.344 251.892ZM162.943 257.681L160.859 260.025L160.112 259.361L162.494 256.681H165.143H166.857H169.506L171.888 259.361L171.141 260.025L169.057 257.681H166.857H165.143H162.943Z"
                  fill="#7A8B95"
                />
              </g>
              <text
                x="186"
                y="259"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                Jack Grenouille
              </text>
              <rect
                width="275"
                height="44"
                transform="translate(292 232.215)"
                fill="white"
              />
              <path
                d="M315.893 245.215C315.151 245.218 314.442 245.281 313.818 245.39C311.981 245.711 311.647 246.383 311.647 247.622V249.259H315.989V249.805H310.018C308.756 249.805 307.651 250.555 307.306 251.982C306.907 253.617 306.889 254.638 307.306 256.346C307.614 257.617 308.351 258.523 309.613 258.523H311.106V256.561C311.106 255.144 312.346 253.894 313.818 253.894H318.155C319.362 253.894 320.326 252.91 320.326 251.711V247.622C320.326 246.459 319.333 245.584 318.155 245.39C317.409 245.267 316.635 245.212 315.893 245.215ZM313.545 246.531C313.993 246.531 314.36 246.899 314.36 247.352C314.36 247.803 313.993 248.168 313.545 248.168C313.095 248.168 312.73 247.803 312.73 247.352C312.73 246.899 313.095 246.531 313.545 246.531Z"
                fill="#768FA2"
              />
              <path
                d="M320.867 249.805V251.711C320.867 253.19 319.6 254.434 318.155 254.434H313.818C312.63 254.434 311.647 255.44 311.647 256.616V260.705C311.647 261.869 312.67 262.554 313.818 262.888C315.192 263.287 316.51 263.359 318.155 262.888C319.248 262.574 320.326 261.945 320.326 260.705V259.069H315.989V258.523H322.496C323.758 258.523 324.228 257.653 324.667 256.346C325.12 255.001 325.101 253.707 324.667 251.982C324.355 250.739 323.76 249.805 322.496 249.805H320.867ZM318.428 260.16C318.878 260.16 319.243 260.525 319.243 260.976C319.243 261.428 318.878 261.796 318.428 261.796C317.979 261.796 317.613 261.428 317.613 260.976C317.613 260.525 317.979 260.16 318.428 260.16Z"
                fill="#768FA2"
              />
              <text
                x="340"
                y="259"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                numpy
              </text>
            </g>
            <g>
              <mask id="path-90-inside-11_2375_90772" fill="white">
                <path d="M30 276.215H146V320.215H30V276.215Z" />
              </mask>
              <path d="M30 276.215H146V320.215H30V276.215Z" fill="white" />
              <path
                d="M145 276.215V320.215H147V276.215H145Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-90-inside-11_2375_90772)"
              />
              <text
                x="46"
                y="302"
                fontSize="11px"
                fontFamily="var(--font-family-mono)"
                fill="#4E6978"
              >
                GET
              </text>
              <rect
                x="98"
                y="286.715"
                width="36"
                height="23"
                rx="4"
                fill="#E2FCF0"
              />
              <text
                x="106"
                y="302"
                fontSize="10px"
                fontFamily="var(--font-family-mono)"
                letterSpacing="0.04em"
                fill="#005346"
              >
                200
              </text>
              <mask id="path-95-inside-12_2375_90772" fill="white">
                <path d="M146 276.215H292V320.215H146V276.215Z" />
              </mask>
              <path d="M146 276.215H292V320.215H146V276.215Z" fill="white" />
              <path
                d="M291 276.215V320.215H293V276.215H291Z"
                fill="#092F45"
                fillOpacity="0.05"
                mask="url(#path-95-inside-12_2375_90772)"
              />
              <g>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M164.251 294.382L166.728 291.905H168.536L171.012 294.382V296.19L168.536 298.666H166.728L165.897 297.835L164.216 299.516L166.005 301.304L165.298 302.011L163.509 300.223L161.988 301.744V302.295L163.51 303.818L162.803 304.525L160.988 302.709V301.33L165.19 297.128L164.251 296.19V294.382ZM165.251 294.796V295.776L167.142 297.666H168.122L170.012 295.776V294.796L168.122 292.905L167.142 292.905L165.251 294.796Z"
                  fill="#5F7886"
                />
              </g>
              <text
                x="186"
                y="303"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                pub_token
              </text>
              <rect
                width="275"
                height="44"
                transform="translate(292 276.215)"
                fill="white"
              />
              <path
                opacity="0.9"
                d="M305.469 288.215C304.655 288.215 304 288.87 304 289.684V306.746C304 307.56 304.655 308.215 305.469 308.215H322.531C323.345 308.215 324 307.56 324 306.746V289.684C324 288.87 323.345 288.215 322.531 288.215H305.469ZM308.275 292.651L319.806 292.667L319.798 304.197H316.912L316.92 295.545H314.04L314.033 304.19H308.261L308.275 292.651Z"
                fill="#768FA2"
              />
              <text
                x="340"
                y="303"
                fontSize="14px"
                fontFamily="var(--font-family-body)"
                fill="var(--brand-color-grey-9)"
              >
                lodash
              </text>
            </g>
          </g>
        </motion.g>
        <defs>
          <filter
            id="filter0_d_2375_90772"
            x="0"
            y="0.214844"
            width="597"
            height="98"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="20" />
            <feGaussianBlur stdDeviation="15" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.921569 0 0 0 0 0.313726 0 0 0 0 0.439216 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2375_90772"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2375_90772"
              result="shape"
            />
          </filter>
          <filter
            id="filter1_d_2375_90772"
            x="0"
            y="46.2148"
            width="597"
            height="324"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="20" />
            <feGaussianBlur stdDeviation="15" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.921569 0 0 0 0 0.313726 0 0 0 0 0.439216 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_2375_90772"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_2375_90772"
              result="shape"
            />
          </filter>
        </defs>
      </g>
    </Explainer>
  );
};

export default ImproveDecisionMaking;
